import { modalBodyLock, modalBodyLockClear } from './bodyLock.js';

export const clinicsWardsCentersSearch = () => {
    const clinicsButton = document.getElementById('clinics-button');

    if (!clinicsButton) {
        return;
    }

    let ScrollTop = 0;
    const overviewContent = document.querySelector('#overview-content');

    const htmlTarget = document.querySelector('html');

    const allButton = document.getElementById('all-button');

    const alphabetContainer = document.getElementsByClassName(
        'inner-alphabet-sticky-top'
    );

    const clinicsWardsCentersChoiceButtons = document.getElementsByClassName(
        'clinics-wards-centers-choice'
    );

    const queryButton = document.getElementById(
        'clinic-ward-center-query-button'
    );

    const searchInputField = document.getElementById(
        'clinic-ward-center-query'
    );

    const polyclinicsContentHolder = document.querySelector(
        '#polyclinics-detail-content'
    );

    const modalBackgroudPolyclinics = document.querySelector(
        '.modal-overlay-infosect-polyclinics'
    );
    const modalInnerPolyclinics = document.querySelector(
        '.modal-infosect-outer-polyclinics'
    );
    const closeModalPolyclinics = document.querySelector(
        '.info-popup-close-polyclinics'
    );

    function debounce(callback, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                callback.apply(this, args);
            }, wait);
        };
    }

    function getUrlParameter(sParam) {
        const sPageUrl = window.location.search.substring(1);
        const sUrlVariables = sPageUrl.split('&');
        let sParameterName;
        let i;

        for (i = 0; i < sUrlVariables.length; i++) {
            sParameterName = sUrlVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined
                    ? true
                    : decodeURIComponent(sParameterName[1]);
            }
        }

        return undefined;
    }

    function getData(event) {
        // Reset the buttons
        if (clinicsWardsCentersChoiceButtons) {
            Array.from(clinicsWardsCentersChoiceButtons).forEach((element) => {
                element.classList.remove('dark');
            });
        }

        // Get the input values.
        let showFromButtonClick = '';
        let showFromQueryString = '';
        let searchStringFromInputField = '';
        let searchStringFromQueryString = '';

        let show = '';
        let searchString = '';
        let language = 'nl';

        if (htmlTarget.getAttribute('lang')) {
            language = htmlTarget.getAttribute('lang');
        }

        if (
            event &&
            event.target.classList.contains('clinics-wards-centers-choice')
        ) {
            showFromButtonClick = event.target.dataset.show;
        }

        if (
            event &&
            event.target.classList.contains('clinic-ward-center-query-input') &&
            searchInputField &&
            searchInputField.value
        ) {
            searchStringFromInputField = searchInputField.value;
        }

        if (!event) {
            showFromQueryString = getUrlParameter('show');
            searchStringFromQueryString = getUrlParameter('searchstring');
        }

        // Set the state.
        if (showFromButtonClick) {
            show = showFromButtonClick;
            event.target.classList.add('dark');
            searchInputField.value = '';
            searchString = '';
        }

        if (showFromQueryString) {
            show = showFromQueryString;

            const buttonName = `${show}-button`;

            const buttonToActivate = document.getElementById(buttonName);
            buttonToActivate.classList.add('dark');
        }

        if (searchStringFromInputField) {
            searchString = searchStringFromInputField;
        }

        if (!event && searchStringFromQueryString) {
            searchString = searchStringFromQueryString;
            searchInputField.value = searchStringFromQueryString;
        }

        if (!show && !searchString) {
            show = 'all';
        }

        if (searchString) {
            show = 'all';
        }

        if (show === 'all') {
            allButton.classList.add('dark');
        }

        const url = `/partials/clinicswardscenterslist?show=${show}&searchstring=${searchString}&language=${language}`;
        const queryString = url.split('?')[1];

        const baseLocation = window.location.href.split('?')[0];
        const windowUrl = `${baseLocation}?show=${show}&searchstring=${searchString}${window.location.hash}`;

        window.history.replaceState(null, null, windowUrl);

        // eslint-disable-next-line no-undef
        $.ajax({
            type: 'GET',
            url,
            data: queryString,
            success(data) {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data, 'text/html');

                const alphabetList = htmlDoc.getElementById('alphabet-list');
                const itemList = htmlDoc.getElementById('item-list');

                $('#content-target').html(itemList.innerHTML);
                $('#alphabet-target').html(alphabetList);
            },
        });
    }

    // Set up events.

    document.addEventListener('focusin', function (e) {
        if (e.target.classList.contains('filter-btn')) {
            if (alphabetContainer) {
                alphabetContainer[0].classList.remove('sticky-hidden-top');
            }
        }
    });

    document.addEventListener('click', function (e) {
        const alphabetLink = e.target.closest('.alphabetic-link');

        if (alphabetLink) {
            modalBackgroudPolyclinics.classList.remove('overlay-invisible');
            modalInnerPolyclinics.classList.remove('hidden-modal');
            htmlTarget.setAttribute('data-scrolldir', 'up');

            closeModalPolyclinics.setAttribute(
                'data-content-id',
                alphabetLink.dataset.contentId
            );

            // eslint-disable-next-line no-use-before-define
            showAlphabetDetailInfo(alphabetLink.dataset.contentId);

            ScrollTop = modalBodyLock();
        }

        const anchor = e.target.closest('a[href^="#"]');

        if (anchor) {
            e.preventDefault();

            const href = document.querySelector(anchor.getAttribute('href'));

            if (href) {
                // Set the focus to the first link in this letter group.

                const firstLink = $('div#' + href.id)
                    .find(':nth-of-type(2)')
                    .find(':first')
                    .find(':first');

                firstLink[0].focus();
                firstLink[0].scrollIntoView();

                window.scrollBy(0, -80);

                setTimeout(() => {
                    document
                        .querySelector('html')
                        .setAttribute('data-scrolldir', 'down');
                }, 1000);
            }
        }
    });

    if (clinicsWardsCentersChoiceButtons) {
        Array.from(clinicsWardsCentersChoiceButtons).forEach((element) => {
            element.addEventListener('click', getData);
        });
    }

    if (queryButton) {
        queryButton.addEventListener('click', getData);
    }

    if (searchInputField) {
        searchInputField.addEventListener(
            'keyup',
            debounce((event) => {
                getData(event);
            }, 600)
        );
    }

    // onLoad
    getData(null);

    const showAlphabetDetailInfo = (contentId) => {
        // make a ajax call to the server
        if (!polyclinicsContentHolder) {
            return;
        }
        const baseUrl = polyclinicsContentHolder.dataset.apiUrl;

        const url = `${baseUrl}?contentId=${contentId}`;

        const loaderMessage = document.querySelector('#loader-message');

        if (loaderMessage) {
            $.blockUI({
                message: $('#loader-message'),
            });
        }

        // eslint-disable-next-line consistent-return
        return fetch(url)
            .then((response) => response.text())
            .then((data) => {
                polyclinicsContentHolder.style.visibility = 'visible';
                polyclinicsContentHolder.style.display = 'block';
                polyclinicsContentHolder.innerHTML = data;

                const hiddenAttributeForFooter =
                    document.createAttribute('hidden');
                const hiddenAttributeForOverviewContent =
                    document.createAttribute('hidden');

                overviewContent.setAttributeNode(
                    hiddenAttributeForOverviewContent
                );

                const footer = document.querySelector('footer');
                footer.setAttributeNode(hiddenAttributeForFooter);

                $.unblockUI();
            })
            .catch((ex) => {
                // eslint-disable-next-line no-console
                console.log('error', ex);
            });
    };
};
